"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_modal_1 = __importDefault(require("react-modal"));
const Modal = ({ children, ...props }) => {
    const customStyles = {
        overlay: {
            'backgroundColor': 'rgba(107, 114, 128, 0.75)',
        }
    };
    return (react_1.default.createElement(react_modal_1.default, { style: customStyles, ariaHideApp: false, className: "w-full max-w-lg p-6 bg-white shadow-xl rounded-lg relative outline-none", ...props },
        react_1.default.createElement("div", { className: "hidden sm:block absolute top-0 right-0 pt-4 pr-4" },
            react_1.default.createElement("button", { onClick: props.onRequestClose, className: "bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500" },
                react_1.default.createElement("span", { className: "sr-only" }, "Close"),
                react_1.default.createElement("svg", { className: "h-6 w-6", xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", stroke: "currentColor", "aria-hidden": "true" },
                    react_1.default.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", d: "M6 18L18 6M6 6l12 12" })))),
        children));
};
exports.default = Modal;
